module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"table":{"quantity":"Qty","type":"Ticket Type","events":"Special Events","vouchers":"Vouchers","wallet":"Download Wallet","download":"Download","tour":"Experience"},"wallet":{"trademark":"Apple and iPhone are trademarks of Apple Inc., registered in the U.S. and other countries."}}}')
  delete Component.options._Ctor
}
